import axios from "axios";
import Cookies from "js-cookie";

export const setupInterceptors = () => {
  axios.interceptors.request.use(
    async (config) => {
      let accessToken = Cookies.get("accessToken");
      let accessTokenExpiry = Cookies.get("accessTokenExpiry");

      if (!accessTokenExpiry) {
        console.warn("No access token expiry found in cookies");
        return config;
      }

      let accessTokenExpiryTime;
      try {
        accessTokenExpiryTime = new Date(accessTokenExpiry).getTime();
      } catch (error) {
        console.error("Invalid access token expiry format:", accessTokenExpiry);
        return config;
      }

      const now = Date.now();
      const isAccessTokenExpired = !accessTokenExpiryTime || now >= accessTokenExpiryTime;

      if (isAccessTokenExpired) {
        // console.log("Access token expired, attempting refresh...");
        const refreshToken = Cookies.get("refreshToken");

        if (!refreshToken) {
          console.error("No refresh token available.");
          return Promise.reject("No refresh token available.");
        }

        try {
          const refreshRequestBody = JSON.stringify({ refreshToken });

          // console.log("Refreshing token with payload:", refreshRequestBody);

          const response = await fetch("/api/refresh", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: refreshRequestBody,
          });

          if (!response.ok) {
            throw new Error(`Failed to refresh token: ${response.statusText}`);
          }

          const responseData = await response.json();
          const accessTokenNew = responseData.accessToken;
          const refreshTokenNew = responseData.refreshToken;
          const expiresInNew = responseData.expiresIn;

          const newExpiryTime = new Date(now + expiresInNew * 1000).toISOString();
          
          // In development, secure flag should be false (HTTP), in production true (HTTPS)
          const isProduction = process.env.NODE_ENV === "production";
          const cookieOptions = {
            secure: isProduction,
            sameSite: "Strict",
          };

          Cookies.set("accessToken", accessTokenNew, cookieOptions);
          Cookies.set("refreshToken", refreshTokenNew, cookieOptions);
          Cookies.set("accessTokenExpiry", newExpiryTime, cookieOptions);

          // Verify cookies were set
          const storedToken = Cookies.get("accessToken");
          if (!storedToken) {
            throw new Error("Failed to store refreshed authentication token");
          }

          // console.log("Token refreshed successfully");
          accessToken = accessTokenNew;
        } catch (error) {
          console.error("Error refreshing token:", error);
          return Promise.reject(error);
        }
      }

      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );
};
